<template>
    <li class="mb-1">
        <div class="flex justify-between content-center py-1">
            <label :for="`county-${item.id}`" class="cursor-pointer">
                <input type="checkbox" :id="`county-${item.id}`" :checked="selected" @change="updateFilter"/>
                {{ item.navn }} ({{ item.antall }})
            </label>
            <button v-if="model.showCommunityFilter" @click="childrenToggle" class="px-1 py-0 border border-gray-300 bg-gray-100 cursor-pointer hover:bg-white hover:border-gray-500 leading-none text-xs">
                <font-awesome-icon icon="plus" v-if="!childrenVisible"/>
                <font-awesome-icon icon="minus" class="" v-if="childrenVisible"/>
            </button>
        </div>
        <template v-if="model.showCommunityFilter">
            <ul v-show="childrenVisible" class="bg-green-100 pl-4 pr-1 pt-2 pb-1 -mx-1 mb-2">
                <li v-for="children in children" class="mb-1" :key="children.id">
                    <label :for="`county-${item.id}-${children.id}`" class="cursor-pointer">
                        <input type="checkbox" :id="`county-${item.id}-${children.id}`" :checked="selected"/>
                        {{ children.kommune }}
                    </label>
                </li>
            </ul>
        </template>
    </li>
</template>

<script>
export default {
    props: ['item', 'model', 'selectedCounties'],
    data() {
        return {
            childrenVisible: false,
            children: [],
        };
    },
    computed: {
        selected() {
            return this.selectedCounties.includes(this.item.id);
        }
    },
    methods: {
        childrenToggle() {
            this.childrenVisible = !this.childrenVisible;
        },
        getChildren() {
            this.children = this.model.tiltakItems.filter(measure => measure.fylkeId === this.item.id);
        },
        updateFilter() {
            const data = {
                type: 'counties',
                item: this.item
            };
            this.$emit('toggled', data);
        }
    },
    mounted() {
        this.getChildren();
    },
};
</script>
